import React, { memo } from 'react';
import cn from 'classnames';
import Card from 'components/Card';
import { IconName } from 'components/Icon';
import styles from './AttendeeCard.module.scss';

export interface CardProps {
  /** Card Image URL */
  image: string | undefined;
  /** Card Title */
  name: string;
  /** Card Image Source */
  imageSource?: 'aws';
  isSideIcon?: boolean;
  onSideIconClick?: (event: React.MouseEvent<HTMLElement>) => void;
  onCardClick?: (event: React.MouseEvent<HTMLElement>) => void;
  iconName?: IconName;
  className?: string;
  isCheckbox?: boolean;
  checked?: boolean;
  handleCheckboxChange?: () => void;
}

export const AttendeeCard: React.FC<CardProps> = memo(
  ({
    name,
    image,
    imageSource,
    isSideIcon = false,
    onSideIconClick,
    onCardClick,
    iconName,
    className,
    isCheckbox,
    checked,
    handleCheckboxChange,
  }: CardProps) => {
    return (
      <Card
        title={name}
        image={image}
        imageSource={imageSource}
        imageClassName={styles.cardImage}
        className={cn(styles.cardMain, className)}
        titleClassName={styles.cardTitle}
        isSideIcon={isSideIcon}
        isRounded
        onSideIconClick={onSideIconClick}
        onCardClick={onCardClick}
        sideIcon={iconName}
        isCheckbox={isCheckbox}
        checked={checked}
        handleCheckboxChange={handleCheckboxChange}
      />
    );
  }
);

AttendeeCard.displayName = 'AttendeeCard';
